export default __webpack_public_path__ + "static/media/clockDark.21d73c9e.svg";